const storeFrontUrl = process.env.REACT_APP_SELLER_STOREFRONT_APP || 'https://shopap.in'

// Builds the subdomain based storefront URL, e.g. https://{storeDomain}.shopap.in
export const getStoreUrl = (storeDomain?: string): string => {
  if (!storeDomain) return ''
  try {
    const base = new URL(storeFrontUrl)
    base.hostname = `${storeDomain}.${base.hostname}`
    return base.toString().replace(/\/$/, '')
  } catch {
    return `${storeFrontUrl}/${storeDomain}`
  }
}
